import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { useNativeToken } from '@/context'
import { useWallet } from '@/hooks'
import { CommonWallet } from '@/icons'
import { useTradePersistStore, useWalletModalActions } from '@/store'
import { IToken } from '@/types'

import { useTranslation } from 'react-i18next'

import { WalletInfo } from '../wallet-dropdown/WalletInfo'

interface ConnectButtonProps {
  token: IToken | null
}

const ConnectButton: React.FC<ConnectButtonProps> = ({ token }) => {
  const { setShowWalletModal } = useWalletModalActions()
  const { t } = useTranslation()
  return (
    <Button
      className='px-5'
      onClick={() => {
        setShowWalletModal({
          show: true,
          token,
        })
      }}
    >
      <CommonWallet className='size-6' />
      {t('button.CONNECT_WALLET')}
    </Button>
  )
}

export const WalletConnection = () => {
  const { wallets } = useWallet()
  const { fromToken } = useTradePersistStore()
  const [isOpenWalletInfo, setIsOpenWalletInfo] = useState(false)
  const walletRightChain = wallets[fromToken?.networkId ?? '']
  const connectedWallet = walletRightChain || Object.values(wallets).find((wallet) => wallet?.isConnected)
  const token = useNativeToken(connectedWallet?.network) || fromToken
  const networkInfo = connectedWallet?.networkInfo

  if (!networkInfo) return <ConnectButton token={token} />

  return <WalletInfo isOpen={isOpenWalletInfo} setOpen={setIsOpenWalletInfo} token={token} />
}
